import { ALL_COMPANIES, MST_CUST_ID } from 'containers/pages/users/constants';

/**
 * @function addCustName
 * @async
 * @param { Array } users
 * @param { Array } companies
 * @returns { Promise<Array> } addedCustName
 */
function addCustName(users, companies) {
	let userObj = {};

	const addedCustName = users.map((user) => {
		companies.map((company) => {
			if (user[MST_CUST_ID] === company.Id) {
				userObj = user;
				userObj.custName = company.Name;
			} else if (user[MST_CUST_ID] === '') {
				userObj = user;
				userObj.custName = ALL_COMPANIES;
			}
			return userObj;
		});
		return userObj;
	});
	return addedCustName;
}

export default addCustName;
